import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import Home from './pages/Home';
import ProductDetail from './pages/ProductDetail';
import Checkout from './pages/Checkout';
import CategoryPage from './pages/CategoryPage';
import CartPage from './pages/CartPage';
import WishlistPage from './pages/WishlistPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import FAQPage from './pages/FAQPage';
import ShippingPage from './pages/ShippingPage';
import ReturnsPage from './pages/ReturnsPage';
import { CartProvider } from './context/CartContext';
import { WishlistProvider } from './context/WishlistContext';
import { ThemeProvider } from './context/ThemeContext';

function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/254724474097"
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-fab"
      aria-label="Chat with us on WhatsApp"
    >
      {/* WhatsApp SVG icon */}
      <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="16" cy="16" r="16" fill="#25D366"/>
        <path
          d="M22.9 9.1A9.7 9.7 0 0 0 16 6.4a9.8 9.8 0 0 0-8.5 14.7l-1.1 4 4.1-1.1A9.8 9.8 0 0 0 25.6 16a9.7 9.7 0 0 0-2.7-6.9zm-6.9 15a8.1 8.1 0 0 1-4.1-1.1l-.3-.2-3 .8.8-3-.2-.3a8.2 8.2 0 1 1 6.8 3.8zm4.5-6.1c-.2-.1-1.4-.7-1.6-.8-.2-.1-.4-.1-.5.1-.2.2-.6.8-.8 1-.1.2-.3.2-.5.1a6.5 6.5 0 0 1-1.9-1.2 7.1 7.1 0 0 1-1.3-1.6c-.1-.2 0-.4.1-.5l.4-.4.2-.4v-.4l-.8-1.8c-.2-.5-.4-.4-.5-.4h-.5a.9.9 0 0 0-.7.3 2.9 2.9 0 0 0-.9 2.1 5 5 0 0 0 1.1 2.7 11.5 11.5 0 0 0 4.4 3.9c.6.3 1.1.4 1.5.3a2.6 2.6 0 0 0 1.7-1.2 2.1 2.1 0 0 0 .1-1.2c0-.1-.2-.2-.4-.3z"
          fill="#fff"
        />
      </svg>
      <span className="whatsapp-fab-tooltip">Chat with us</span>
    </a>
  );
}

function SeoProductRedirect() {
  const { slug = '' } = useParams();
  return <Navigate to={`/product/${slug.replace(/\.html$/, '')}`} replace />;
}

function SeoCategoryRedirect() {
  const { slug = '' } = useParams();
  return <Navigate to={`/category/${slug.replace(/\.html$/, '')}`} replace />;
}

function App() {
  return (
    <ThemeProvider>
    <CartProvider>
    <WishlistProvider>
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/product/:slug" element={<ProductDetail />} />
        <Route path="/seo/product/:slug" element={<SeoProductRedirect />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/wishlist" element={<WishlistPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/shipping" element={<ShippingPage />} />
        <Route path="/returns" element={<ReturnsPage />} />
        <Route path="/category/:slug" element={<CategoryPage />} />
        <Route path="/seo/category/:slug" element={<SeoCategoryRedirect />} />
      </Routes>
      <WhatsAppButton />
    </Router>
    </WishlistProvider>
    </CartProvider>
    </ThemeProvider>
  );
}

export default App;
